
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './components/theme-provider'
import { registerServiceWorker } from './utils/serviceWorker'

// Create a client
const queryClient = new QueryClient()

// Register service worker for production environment
if (import.meta.env.PROD) {
  registerServiceWorker();
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="system" enableSystem attribute="class" storageKey="travel-cms-ui-theme">
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </ThemeProvider>
);
